// extracted by mini-css-extract-plugin
module.exports = {"wrapper_qr_video":"qr_style_wrapper_qr_video__1sjop","wrapper_qr_video_error":"qr_style_wrapper_qr_video_error__3B4wC","window":"qr_style_window__K66h-"};